<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar ref="system-bar" />
      </div>
      <div>
        <ViewHeader :title="$organization.calendarConfig().data.title" />
      </div>
      <div class="d-flex align-center flex-fill overflow-auto">
        <div class="w-100">
          <Calendar />
          <section
            v-if="attentionType && attentionType.channels.length > 1 && $route.query.requestChannel"
            id="full-screen-modal"
          >
            <ChannelSelector
              ref="channel-selector"
              :attentionType="attentionType"
              :open="true"
              :persistent="true"
            />
          </section>
        </div>
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import { mapActions } from 'vuex'

@Component({
  components: {
    Calendar: () => import(/* webpackPrefetch: true */ '@/views/calendar/components/Calendar.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    ViewHeader: () => import(/* webpackPrefetch: true */ '@/components/ViewHeader.vue'),
    ChannelSelector: () => import(/* webpackPrefetch: true */ '@/views/attention-types/components/ChannelSelector.vue')
  },
  computed: {
    attentionType () {
      const data = this.$organization.attentionTypesConfig().data
      const options = data?.options ?? []

      return options.find((option) => option.id === 2) ?? null;
    }
  },
  methods: {
    ...mapActions({
      setAttentionChannel: 'setAttentionChannel'
    })
  }
})
export default class Index extends Vue {
  mounted () {
    if (this.attentionType && this.attentionType.channels.length === 1) {
      const channel = this.attentionType.channels[0]
      this.setAttentionChannel(channel)
    }
  }

  data () {
    return {
      error: {
        icon: null,
        title: null,
        description: null
      }
    }
  }

  accessDenied () {
    this.error.icon = 'mdi-cancel'
    this.error.title = 'El servicio no está disponible.'
    this.error.description = 'Por favor intentelo luego.'
  }
}
</script>
